import useStore from '@/stores/useStore.js'
import { useDefaultOrganizationId } from './useDefaultOrganizationId.ts'
import { Timestamp } from 'firebase/firestore'

export function useCurrentSubscription() {
  const organizations = useStore(state => state.organizations)
  const currentOrganizationId = useDefaultOrganizationId()
  const userId = useStore(state => state.user?.id)
  if (organizations.length === 0 || !userId) {
    return null
  }
  // we won't be doing org selector for now
  const subscription = organizations.find(org => org.id === currentOrganizationId)
    ?.subscription as {
    id: string
    status: string
    priceId: string
    productId: string
    createdAt: Timestamp
    currentPeriodEnd: Timestamp
    currentPeriodStart: Timestamp
    isActive: boolean
    provisionedVMs: number
    customerId: string
  } | null

  return subscription?.isActive ? subscription : null
}
